"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _localization = require("@lt/localization");
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _FacilitiesItem = _interopRequireDefault(require("../FacilitiesItem"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var FacilitiesList = function FacilitiesList(_ref) {
  var items = _ref.items,
    _ref$showBestTitle = _ref.showBestTitle,
    showBestTitle = _ref$showBestTitle === void 0 ? false : _ref$showBestTitle,
    _ref$showItemBackgrou = _ref.showItemBackground,
    showItemBackground = _ref$showItemBackgrou === void 0 ? false : _ref$showItemBackgrou,
    _ref$isMobile = _ref.isMobile,
    isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile,
    _ref$inColumns = _ref.inColumns,
    inColumns = _ref$inColumns === void 0 ? false : _ref$inColumns;
  var _useTranslation = (0, _localization.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement(StyledFacilitiesList, {
    $showBestTitle: showBestTitle
  }, showBestTitle && /*#__PURE__*/_react["default"].createElement(StyledTitle, null, t('hotel.facilities.best')), /*#__PURE__*/_react["default"].createElement(Container, {
    $isMobile: isMobile,
    $inColumns: inColumns
  }, items.map(function (_ref2) {
    var text = _ref2.text,
      icon = _ref2.icon;
    return /*#__PURE__*/_react["default"].createElement(StyledFacilitiesItem, {
      $inColumns: inColumns,
      isMobile: true,
      withGeneralStyles: true,
      showItemBackground: showItemBackground,
      key: text,
      icon: icon
    }, text);
  })));
};
var StyledFacilitiesList = _styledComponents["default"].div.withConfig({
  displayName: "FacilitiesList__StyledFacilitiesList",
  componentId: "sc-1cs5i9c-0"
})(["padding:7px 10px;", ""], function (props) {
  return props.$showBestTitle && (0, _styledComponents.css)(["background-color:var(--lightorange);border-radius:var(--border-radius);margin-bottom:7px;"]);
});
var StyledFacilitiesItem = (0, _styledComponents["default"])(_FacilitiesItem["default"]).withConfig({
  displayName: "FacilitiesList__StyledFacilitiesItem",
  componentId: "sc-1cs5i9c-1"
})(["", ""], function (_ref3) {
  var $inColumns = _ref3.$inColumns;
  return $inColumns && (0, _styledComponents.css)(["margin-bottom:8px;"]);
});
var StyledTitle = _styledComponents["default"].div.withConfig({
  displayName: "FacilitiesList__StyledTitle",
  componentId: "sc-1cs5i9c-2"
})(["color:var(--black);margin-bottom:8px;"]);
var Container = _styledComponents["default"].ul.withConfig({
  displayName: "FacilitiesList__Container",
  componentId: "sc-1cs5i9c-3"
})(["", ""], function (_ref4) {
  var $isMobile = _ref4.$isMobile,
    $inColumns = _ref4.$inColumns;
  return $inColumns ? (0, _styledComponents.css)(["column-count:2;column-gap:8px;"]) : $isMobile ? (0, _styledComponents.css)(["display:flex;flex-direction:column;gap:8px;"]) : (0, _styledComponents.css)(["display:flex;flex-wrap:wrap;gap:4px;"]);
});
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(FacilitiesList);